$(document).ready(function () {
    var initScrollToTop = function () {
        handleScrollToTop();

        if ($('.cookie_notification:visible').length) {
            adjustPositionOfScrollToTop();
            $(window).resize(function () {
                adjustPositionOfScrollToTop();
            });

        }
    };

    // function to handle scroll to top
    var handleScrollToTop = function () {
        var minScrollValue = (window.innerHeight) ? window.innerHeight * 1.2 : 1400;
        if ($(this).scrollTop() > minScrollValue) {
            $('[data="scrollToTop"]').fadeIn();
        } else {
            $('[data="scrollToTop"]').fadeOut();
        }
    };

    var adjustPositionOfScrollToTop = function () {
        var height = ($('.cookie_notification').outerHeight() + 10) + 'px';
        $('[data="scrollToTop"]').css('bottom', height);

    };

    // initial calling of handle scroll to top
    initScrollToTop();


    // scroll event to call handle scroll to top
    $(window).scroll(function () {
        handleScrollToTop();
    });

    // click event to scroll to top
    $('[data="scrollToTop"]').click(function () {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

});